
const urlParams = new URLSearchParams(window.location.search);

export const debugMode = urlParams.get('debug') || '0';
export const fuzzyEngine = urlParams.get('fuzzy') || 'fuse';

// uFuzzy disabled, always use Fuse.js only
export const USE_FUSE_ONLY = true;

// Fallback (нечеткий поиск при 0 результатах) законсервирован
export const ENABLE_FUZZY_FALLBACK = false;

export const SEARCH_LIMIT = 300;
export const RESULT_LIMIT_FOR_PAUSE = 50;

if (debugMode === '1') {
    console.log('[FilterManager] Fuzzy engine: Fuse.js only (uFuzzy disabled, fallback disabled)');
}
